import { StringFormat } from "@packages/common";
import type { FilterDTO, FilterItemDTO } from "../../search";

export abstract class OfferTransformer {
  /**
   * Transforms a `FilterDTO` for "HotDeal" offers by sorting the items based on a predefined
   * priority order for specific offers (e.g., "mega-feirao", "black-feirao"). Items matching
   * these names appear at the top, in the specified order, followed by other items alphabetically.
   *
   * @param {FilterDTO} filter - The filter object to transform.
   * @returns {FilterDTO} - The transformed filter object with sorted items.
   */
  static transform(filter: FilterDTO): FilterDTO {
    if (!filter || filter.name !== "HotDeal") return filter;

    const hotDealOrder = ["mega-feirao", "black-feirao"];

    const sortedItems: FilterItemDTO[] = filter.items.slice().sort((a, b) => {
      const aIndex = hotDealOrder.indexOf(StringFormat.formatSlug(a.name));
      const bIndex = hotDealOrder.indexOf(StringFormat.formatSlug(b.name));

      if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;

      return a.name.localeCompare(b.name);
    });

    return {
      ...filter,
      items: sortedItems,
    };
  }
}
